<template>
  <div class="w-full h-full p-10px bg-[var(--contentBgColor)] flex">
    <div class="h-full w-[30%]">
      <div class="flex justify-between w-full mb-10px">
        <el-button type="primary" size="mini" @click="goBack">
          <i class="el-icon-back"></i>
          返回
        </el-button>
        <el-select
          class="!w-200px"
          :disabled="!player"
          v-model="currentScene"
          @change="getSceneDetail"
        >
          <el-option
            v-for="item in sceneList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div
        class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px flex justify-between items-center"
      >
        <span>任务列表</span>
      </div>
      <div class="mb-10px w-full">
        <el-input
          v-model="search.keyWords"
          clearable
          class="!w-200px mr-10px"
          placeholder="任务名称或编码"
          @change="searchList()"
        ></el-input>
        <el-select
          v-model="search.level"
          class="!w-200px"
          clearable
          placeholder="计划等级"
          @change="searchList()"
        >
          <el-option label="二级计划" value="二级计划"></el-option>
          <el-option label="三级计划" value="三级计划"></el-option>
        </el-select>
      </div>

      <el-table
        v-loading="loading"
        class="mb-10px"
        row-key="id"
        ref="taskRef"
        highlight-current-row
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :data="tableData"
        border
        height="calc(45% - 50px)"
        stripe
        @current-change="changeSelectedRow"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed || false"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px">
        <span>关联对象</span>
      </div>
      <div class="mb-10px">
        <el-button type="primary" size="mini" @click="associate" v-show="isLoadFinish"
          >绑定</el-button
        >
      </div>
      <el-table
        v-loading="loadingObj"
        :data="objectData"
        border
        height="calc(55% - 162px)"
        stripe
        @row-click="rowClick"
      >
        <el-table-column label="对象编码" prop="code"></el-table-column>
        <el-table-column label="对象名称" prop="name"></el-table-column>
        <el-table-column label="操作" align="left" width="80px">
          <template slot-scope="scope">
            <el-button size="mini" @click="removeItem(scope.row)">移除</el-button>
          </template></el-table-column
        >
      </el-table>
    </div>
    <div class="h-full w-[calc(70%-10px)] ml-10px relative">
      <SceneView
        v-if="isReday"
        :sceneOptions="sceneOptions"
        @sendPlayer="sendPlayer"
        @loadModelEnd="loadModelEnd"
      ></SceneView>
    </div>
  </div>
</template>

<script>
import { ModelSceneApi } from '@wiz-api/scene-management'
import { PlanTaskApi, TaskBindModelApi } from '@wiz-api/construction-schedule-management'
import SceneView from '../components/sceneView'

const modelSceneApi = new ModelSceneApi()
const planTaskApi = new PlanTaskApi()
const taskBindModelApi = new TaskBindModelApi()
export default {
  components: { SceneView },
  data() {
    return {
      search: { keyWords: '', level: '' },
      columns: [
        { prop: 'code', label: '任务编码', width: 130 },
        { prop: 'name', label: '任务名称' },
        { prop: 'level', label: '任务等级', width: 80 },
        { prop: 'bindModelCount', label: '关联对象数量' },
      ],
      tableData: [],
      sceneList: [],
      currentScene: '',
      loading: true,
      objectData: [],
      isLoadFinish: false,
      page: {
        no: 1,
        size: 20,
        total: 0,
      },
      sceneOptions: {
        isEnableGis: false,
        latitude: 0,
        longitude: 0,
        name: '',
        id: '',
        folderId: '',
        jsonData: '',
      },
      isReday: false,
      player: null,
      currentItem: {},
      loadingObj: false,
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    async getSceneDetail() {
      this.isLoadFinish = false
      const [err, res] = await modelSceneApi.get(this.currentScene)
      if (!err) {
        const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({
          id: this.currentScene,
        })
        if (!jsonErr) {
          const data = _.pick(res, [
            'isEnableGis',
            'latitude',
            'longitude',
            'name',
            'id',
            'folderId',
          ])
          this.sceneOptions = { ...data, jsonData: jsonRes }
        }
        this.isReday = true
        this.getObjectList()
      }
    },
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 9999,
      })
      if (!err) {
        this.sceneList = res.items
        this.currentScene = this.sceneList[0].id
        this.getSceneDetail()
      }
    },
    async getList(operate = false, loading = true) {
      loading ? (this.loading = true) : false
      operate ? (this.tableData = []) : null
      const [err, res] = await planTaskApi.getList({
        skipCount: operate ? 0 : (this.page.no - 1) * this.page.size,
        maxResultCount: operate ? this.page.no * this.page.size : this.page.size,
        ...this.search,
      })
      if (!err) {
        this.page.total = res.totalCount

        this.tableData.push(...res.items)
      }
      this.loading = false
    },
    async removeItem(row) {
      this.$confirm(this.$t('是否确定移除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(async () => {
        const [err, res] = await taskBindModelApi.callDelete(row.id)
        if (!err) {
          this.$message.success('移除成功!')

          this.getList(true)
          this.getObjectList()
        }
      })
    },
    async getObjectList() {
      if (!this.currentItem.id) {
        this.loadingObj = false
        return (this.objectData = [])
      }
      this.loadingObj = true
      const [err, res] = await taskBindModelApi.getList({
        taskId: this.currentItem.id,
        sceneId: this.currentScene,
      })
      if (!err) {
        this.objectData = res.items
      }
      this.loadingObj = false
    },
    async associate() {
      if (!this.currentItem.id) return this.$message.warning('请先选择任务再进行绑定')

      const re = await this.player.Native.Node.getSeletedNodes()
      if (!re || re.length === 0) return this.$message.warning('请先选择模型再进行绑定')

      const { code, name } = await this.player.Native.Node.getProperty(re[0], ['code', 'name'])
      const [err] = await taskBindModelApi.create({
        body: {
          code,
          name,
          taskId: this.currentItem.id,
          sceneId: this.currentScene,
        },
      })
      if (!err) {
        this.$message.success('绑定成功!')
        this.getList(true)
        this.getObjectList()
      }
    },
    sendPlayer(val) {
      this.player = val
    },
    async changeSelectedRow(row) {
      this.objectData = []
      this.currentItem = row
      this.getObjectList()
      const res = await this.player.Native.Node.getSeletedNodes()
      if (res || res.length !== 0) {
        this.player.Native.Node.unSelectNodes(res)
      }
    },
    loadModelEnd() {
      this.isLoadFinish = true
    },
    async rowClick(row) {
      const res = await this.player.Native.Node.findNode(0, {
        names: [row.name],
        codes: [row.code],
      })
      const node = res.codes ? res.codes[row.code] : res.names ? res.names[row.name] : null
      if (node) {
        await this.player.Native.Node.selectNodes([node.node])
        await this.player.Native.Camera.moveToNode(node.node, 2)
      }
    },
    goBack() {
      this.$router.push(`${this.basePath}/construction-schedule-management-vulkan/index`)
    },
    scrollEvent: _.debounce(async function (evt) {
      const el = evt.srcElement
      console.log(el.scrollTop + el.clientHeight >= el.scrollHeight - 10)

      if (
        this.tableData.length !== 0 &&
        el.scrollTop + el.clientHeight >= el.scrollHeight - 10 &&
        this.tableData.length < this.page.total
      ) {
        this.page.no = this.page.no + 1
        await this.getList(false)
      }
    }, 500),
    async searchList() {
      this.page.no = 1
      this.$refs.taskRef.setCurrentRow()
      this.currentItem = null
      this.tableData = []
      this.objectData = []
      await this.getList()
    },
  },

  async mounted() {
    this.getSceneList()
    this.getList()
    this.$nextTick(() => {
      this.$refs.taskRef.$el
        .querySelector('.el-table__body-wrapper')
        .addEventListener('scroll', this.scrollEvent)
    })
  },
  destroyed() {
    this.$refs.taskRef.$el
      .querySelector('.el-table__body-wrapper')
      .removeEventListener('scroll', this.scrollEvent)
  },
}
</script>

<style>
</style>
